import React from 'react';
import ReactMarkdown from 'react-markdown';
import { ReactMarkdownOptions } from 'react-markdown/lib/react-markdown';
import { Link } from '../PlatformFunctionality';
import deepmerge from 'ts-deepmerge';
import { styles } from './MarkdownBlock.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { formatMarkdownString } from './formatMarkdownString';

export type MarkdownBlockProps = ReactMarkdownOptions & { shouldLinkOpenInNewTab?: boolean };

export const MarkdownBlock = ({ children, shouldLinkOpenInNewTab, ...props }: MarkdownBlockProps) => {
  const defaultProps: Omit<MarkdownBlockProps, 'children'> = {
    skipHtml: true,
    components: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      a: ({ node, className, ...props }) => (
        <Link
          href=""
          className={classNames(styles.link, className)}
          {...(shouldLinkOpenInNewTab ? { target: '_blank', rel: 'noreferrer' } : {})}
          {...props}
        />
      ),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      p: ({ node, className, ...props }) => <p className={classNames(styles.paragraph, className)} {...props} />,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      ul: ({ node, className, ordered, ...props }) => <ul className={classNames(styles.list, className)} {...props} />,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      ol: ({ node, className, ordered, ...props }) => <ol className={classNames(styles.list, className)} {...props} />,
    },
  };

  return <ReactMarkdown {...deepmerge(defaultProps, props)}>{formatMarkdownString(children)}</ReactMarkdown>;
};
